import { Add, Remove } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

const QtyInputReward = (props) => {
  const { value = 1, onChange, buttonShow = true } = props || {};

  const [qty, setQty] = useState(value);

  useEffect(() => {
    setQty(value);
  }, [value]);

  const handleIncrement = () => {
    const newQty = qty + 1;
    setQty(newQty);
    onChange?.(newQty);
  };

  const handleDecrement = () => {
    const newQty = qty > 1 ? qty - 1 : qty;
    setQty(newQty);
    onChange?.(newQty);
  };

  return (
    <div className="qty-input-container">
      <Button
        onClick={handleDecrement}
        size="small"
        className="qty-button minus"
      >
        <Remove />
      </Button>
      <TextField
        value={qty}
        className="qty-input"
        variant="outlined"
        size="small"
        inputProps={{
          readOnly: true,
          style: { textAlign: "center", width: "50px", pointerEvents: "none" },
        }}
      />
      <Button
        onClick={handleIncrement}
        size="small"
        className="qty-button plus"
      >
        <Add />
      </Button>
    </div>
  );
};

export default QtyInputReward;
